import { Component, OnInit } from '@angular/core';
import { AccountService } from './account.service'
import { AuthService } from '../authentication/auth.service'
import { Router, ActivatedRoute} from '@angular/router';
import * as _ from 'lodash';

@Component({
    providers: [AccountService, AuthService],
    //templateUrl: 'app/accounts/account.component.html'
    template: require('./account.component.html'), 
    
})
 
export class AccountComponent implements OnInit {
    errorAlerts: any[];
    private sub: any; 
    message: string;
    public questions: any[];
    alerts: any[];  
    public question: any;
    public answer: string;
    public currentPassword: string;
    public newPassword: string;

    
    constructor(private router: Router,
        private accountService: AccountService,
        private authService: AuthService, 
        private route: ActivatedRoute) {}    

        //TODO: may not need this 
    ngOnInit() : void{
    }

	timeoutAlert(){
  	    setTimeout(function(){
		    this.errorAlerts = [];				
  		},10000);
  	}

	changePassword(){

		this.alerts = [];

		var pwdData = {
			username: this.authService.getLoggedInUser(),
			currentPassword: this.currentPassword,
			newPassword: this.newPassword
		};

        this.accountService.changePwd(pwdData)
            .subscribe(
                data => {
                    if(data.succeeded) {
				        this.alerts.push({type: 'success', msg: 'Password successfully changed'});
                    }
                    else{
				        this.alerts.push({type: 'danger', msg: data.errors[0]});
                    }
                },
                error => {
                    this.alerts.push({type: 'danger', msg: error});    
                },
                () => this.timeoutAlert()
			);
	}

    //not used for now
  	// getSecurityQuestions(){
  	// 	this.accountService.getSecurityQuestions().
    //         subscribe(
    //             data => {
    //                 this.questions = data;
  	// 			    this.getUserAccountInfo();
    //             },
    //             error => {
  	// 			    this.alerts = [];
  	// 			    this.alerts.push({type: 'danger', 
    //       			    msg: 'An unexpected error occurred while retrieving the list of security questions'});
    //             });
  	// }

    // getUserAccountInfo(){
  	// 	this.accountService.getAccountInfo(this.authService.getLoggedInUser()).
    //         subscribe(
    //             data => {
    //                 this.question = _.find(this.questions, function(q: any){
  	// 				    return q.id === data.questionId;});
  	// 			    this.answer = data.answer;
  	// 		    });
  	// }

    // saveSecurityQuestionAnswer(){
    //     var securityQuestionData = {
	// 	    username: this.authService.getLoggedInUser(),
	// 		questionid: this.question.id,
	// 		answer: this.answer
	// 	};

	// 	this.accountService.saveSecurityQuestionAnswers(securityQuestionData)
    //         .subscribe(
    //             success => {
    //                 this.alerts = [];
	// 				this.alerts.push({type: 'success', msg: 'Security Question saved.'});
    //             },
    //             error => {
	// 			    this.alerts = [];
	// 				this.alerts.push({type: 'danger', msg: 'Unexpected error saving security question'});
    //             },
    //             () => this.timeoutAlert()
    //         );	
	// }

	closeAlert(index: number) {
        this.alerts.splice(index, 1);
  	}
}



/** WEBPACK FOOTER **
 ** ./app/accounts/account.component.ts
 **/